/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

export interface GetEquipementsFromSiteByQrCode$Params {
  idSite: string;
  qr_code: string;
}

export function getEquipementsFromSiteByQrCode(
  http: HttpClient,
  rootUrl: string,
  params: GetEquipementsFromSiteByQrCode$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<{}>> {
  const rb = new RequestBuilder(rootUrl, getEquipementsFromSiteByQrCode.PATH, 'get');
  if (params) {
    rb.path('idSite', params.idSite, {});
    rb.query('qr_code', params.qr_code, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{}>;
    })
  );
}

getEquipementsFromSiteByQrCode.PATH = '/v1/sites/{idSite}/equipements/byQrCode';
